import styled from 'styled-components';
import Flex from 'Shared/ui/Flex';
import T from 'aegisv2/Text';

import CareerBanner from 'SharedCareers/CareerBanner';

import Pagination from '../../Pagination';

export const WrapperCSS = `
border-radius: 5px;
padding: 0px;
flex-direction: column;
align-items: center;
& > * {
  margin-top: 10px;
  margin-bottom: 10px;
}
@media (min-width: 1140px) {
  flex-direction: row;
}
@media (min-width: 1366px) {
  padding: 0;
}
`;

export const PaginationWrapper = styled(Flex)`
  ${WrapperCSS};
  @media (min-width: 678px) {
    justify-content: flex-end;
  }
`;

export const ContentTopWrapper = styled(Flex)`
  margin-bottom: 12px;
  position: relative;
  ${({ hasSubTitle }) =>
    hasSubTitle &&
    `
    align-items: flex-start !important;
    height: 60px;
  `}
  ${WrapperCSS}
  align-items: flex-start;
  margin-bottom: 24px;
  @media (min-width: 1025px) {
    margin-bottom: 0px;
    justify-content: space-between;
  }
`;

export const ResultsTitle = styled(Flex)`
  margin: 0;
  text-align: left;
  & > h1 {
    & > span {
      font-size: 22.43px !important;
      line-height: 28px !important;
    }
    @media (min-width: 1140px) {
      margin-bottom: ${props => (props.hasFilterTagsToShow ? 24 : 32)}px;
    }
  }
`;

export const SubTitle = styled(T)`
  position: absolute;
  top: 36px;
`;

export const OrderByWrapper = styled.div`
  position: relative;
  display: none;
  flex-flow: row nowrap;
  align-items: center;
  margin: 0 !important;
  min-width: 286px;
  flex-shrink: 0;

  & > span {
    display: inline-block;
    margin-right: 18px;
  }
  @media (min-width: 1140px) {
    margin-left: 24px !important;
    display: flex;
  }
`;

export const ScrollTopIconWrapper = styled.div`
  transform: rotate(90deg);
  margin-right: 11px;
`;

export const ScrollTopWrapper = styled(Flex)`
  cursor: pointer;
`;

export const EmptySubTitle = styled(T)`
  display: block;
  margin-bottom: 16px;
`;

export const StyledPagination = styled(Pagination)`
  display: none;
  @media (min-width: 768px) {
    margin: 0;
    display: flex;
  }
`;

// catalog-careers, enable eslint if it is necessary
// eslint-disable-next-line no-unused-vars
export const CareerBannerWrapper = styled(CareerBanner)`
  min-height: 345px;
  height: auto;

  margin-bottom: 30px;
  @media (min-width: 768px) {
    min-height: 256px;
    margin-bottom: 25px;
  }
`;

export const FilterTagWrapper = styled.div`
  display: none;

  @media (min-width: 1025px) {
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    width: 100%;
    margin-bottom: 32px;

    & > button {
      cursor: pointer;
      &:not(:last-child) {
        margin-right: 8px;
      }
      &:last-child {
        margin-left: 8px;
      }
    }
  }
`;

export const FilterMobile = styled.div`
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
`;

export const FilterTag = styled.button`
  padding: 4px 16px;
  display: flex;
  align-items: center;
  outline: none;
  border: 1px solid rgba(75, 34, 244, 0.2);
  background-color: #fff;
  transition: background-color 0.2s ease-in-out;
  margin: 0 8px 0 0;
  & > svg {
    margin-right: 8px;
  }

  &:hover {
    background-color: rgba(0, 153, 255, 0.1);
  }

  @media (min-width: 768px) {
    margin: 0 0 8px 0;
  }
`;
